<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 数据筛选 -->
      <el-row>
        <el-col :span="24">
          <div class="content data_screen">
            <div class="data_screen_line">
              <span class="data_screen_title">首页 — 数据概览</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="content_auto">
        <!-- 中间区域 -->
        <el-row>
          <!-- 库存情况 -->
          <el-col
            :span="12"
            :xs="wi.xs"
            :sm="wi.sm"
            :mg="wi.mg"
            :lg="wi.lg"
            :xl="wi.xl"
          >
            <div class="content">
              <div class="title">绑定设备情况</div>
              <el-row>
                <el-col :span="14">
                  <div
                    id="device_dom"
                    ref="device_dom"
                    class="content_center"
                  ></div>
                </el-col>
                <el-col :span="10">
                  <div class="tip_content">
                    <div
                      class="tip"
                      v-for="(item, index) in device_data.data"
                      :key="item.name"
                    >
                      <span
                        class="tip_color"
                        :style="{
                          'background-color': device_data.color[index],
                        }"
                      />
                      {{ item.name }}
                      <span class="tip_value">{{ item.value }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- 用户数据 -->
          <el-col
            :span="12"
            :xs="wi.xs"
            :sm="wi.sm"
            :mg="wi.mg"
            :lg="wi.lg"
            :xl="wi.xl"
          >
            <div class="content">
              <div class="title">系统状态</div>
              <el-row>
                <el-col :span="12">
                  <div
                    id="system_ram_dom"
                    ref="system_ram_dom"
                    class="content_center"
                  ></div>
                </el-col>
                <el-col :span="12">
                  <div
                    id="system_cpu_dom"
                    ref="system_cpu_dom"
                    class="content_center"
                  ></div>
                </el-col>
                <!-- <el-col :span="10">
                  <div class="tip_content">
                    <div class="tip" v-for="(item,index) in system_data.data" :key="item.name">
                      <span class="tip_color" :style="{'background-color':user_data.color[index]}" />
                      {{item.name}}
                      <span class="tip_value">{{item.value}}</span>
                    </div>
                  </div>
                </el-col>-->
              </el-row>
            </div>
          </el-col>
        </el-row>
        <!-- 底部区域 -->
        <el-row>
          <!-- 用户数据 -->
          <el-col
            :span="12"
            :xs="wi.xs"
            :sm="wi.sm"
            :mg="wi.mg"
            :lg="wi.lg"
            :xl="wi.xl"
          >
            <div class="content">
              <div class="title">活跃情况</div>
              <el-row>
                <el-col :span="14">
                  <div
                    id="user_dom"
                    ref="user_dom"
                    class="content_center"
                  ></div>
                </el-col>
                <el-col :span="10">
                  <div class="tip_content">
                    <div
                      class="tip"
                      v-for="(item, index) in user_data.data"
                      :key="item.name"
                    >
                      <span
                        class="tip_color"
                        :style="{ 'background-color': user_data.color[index] }"
                      />
                      {{ item.name }}
                      <span class="tip_value">{{ item.value }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- 新增变化 -->
          <el-col
            :span="12"
            :xs="wi.xs"
            :sm="wi.sm"
            :mg="wi.mg"
            :lg="wi.lg"
            :xl="wi.xl"
          >
            <div class="content">
              <div class="title">新增变化</div>
              <div
                id="profit_change_dom"
                ref="profit_change_dom"
                class="content_bottom"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  components: {},
  data() {
    return {
      user: null,
      // 自适就
      wi: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 12,
        xl: 12,
      },
      bwi: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 12,
      },
      // 设备
      device_dom: null,
      // 设备数据
      device_data: {
        data: [
          { value: 250, name: "A设备" },
          { value: 500, name: "B设备" },
        ],
        // 库存颜色配置
        color: ["#00CB9F", "#F7BA2A", "#20A0FF"],
        name: "绑定设备情况",
      },
      // 系统状态定时器
      systemInterval: null,
      // 系统数据
      system_cpu_dom: null,
      system_cpu_data: {
        name: "CPU",
        title: "CPU",
        value: 60,
      },
      system_ram_dom: null,
      system_ram_data: {
        name: "RAM",
        title: "RAM",
        value: 90,
      },
      // 用户数据
      user_dom: null,
      user_data: {
        data: [
          { value: 174, name: "活跃用户" },
          { value: 80, name: "使用次数" },
        ],
        color: ["#00CB9F", "#FF4949", "#20A0FF"],
        name: "活跃情况",
      },
      // 收益变化
      profit_change_dom: null,
      profit_change: {
        // X 轴数据
        names: [
          "2020-1",
          "2020-2",
          "2020-3",
          "2020-4",
          "2020-5",
          "2020-6",
          "2020-7",
          "2020-8",
          "2020-9",
          "2020-10",
          "2020-11",
          "2020-12",
        ],
        data1: {
          // 数据1名称
          name: "新增设备",
          // 数据1颜色
          color: "#00CB9F",
          // 数据1 数据
          data: [2, 5, 9, 26, 28, 70, 175, 182, 48, 18, 6, 2],
        },
        data2: {
          // 数据2名称
          name: "新增用户",
          // 数据2颜色
          color: "#FF4949",
          // 数据2 数据
          data: [3, 5, 11, 18, 48, 69, 231, 46, 55, 18, 10, 0],
        },
      },

      // return 结束
    };
  },
  updated() {},
  created() {
    var user = JSON.parse(sessionStorage.getItem("user"));
    this.user = user;
  },
  beforeDestroy(){
    console.log("关闭了")
    // 关闭页面，关闭定时器
    if(this.systemInterval){
      clearInterval(this.systemInterval)
    }
   
  },
  mounted() {
    // 查询新增变化
    this.queryNewData();
    // 查询门锁与用户
    this.queryDeviceAndUser()
    // 查询系统变化
    this.querySystem();
    // 定时查询系统状态,10 秒查一次
    let that = this;
    this.systemInterval = setInterval(function () {
      that.querySystem();
    }, 10000);
  },
  methods: {
    queryDeviceAndUser(){
      let that = this;
    // 查询数据
      this.$axios
        .post("/api/web/home/queryHomeData")
        .then((res) => {
          if (res.data.code == 1000) {
            // 门锁数量
            that.device_data.data[0].value = res.data.data.deviceANumber; // A数量
            that.device_data.data[1].value = res.data.data.deviceBNumber; // B数量
            // 活跃情况
            that.user_data.data[0].value = res.data.data.activeUser; // 活跃用户
            that.user_data.data[1].value = res.data.data.useCount; // 使用次数
            
            // 绘制库存情况
            this.devicekDraw();
            this.userDraw();
            
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询新增变化
    queryNewData(){
      let that = this;
      that.$axios
        .post("/api/web/home/queryHomeNewData")
        .then((res) => {
          if (res.data.code == 1000) {
            // 新增变化
            let dates = [];
            let data1 = [];
            let data2 = [];
            for (var i = res.data.data.length -1; i >= 0; i--) {
              dates.push(res.data.data[i].date);
              data1.push(res.data.data[i].userNumber);
              data2.push(res.data.data[i].deviceNumber);
            }
            that.profit_change.names = dates;
            that.profit_change.data1.data = data1;
            that.profit_change.data2.data = data2;
            //console.log(that.profit_change)

            // 折线图
            this.profitChangeDraw();
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询系统变化
    querySystem(){
      let that = this;
      that.$axios
        .post("/api/web/home/querySystem")
        .then((res) => {
          if (res.data.code == 1000) {
            that.system_cpu_data.value = res.data.data.cpu;
            that.system_ram_data.value = res.data.data.ram;
            // 绘制
            that.systemDraw();
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 库存情况绘制
    devicekDraw() {
      this.device_dom = echarts.init(this.$refs.device_dom);
      this.device_dom.setOption(
        this.createEchartsOptionByPie(this.device_data)
      );
    },
    systemDraw() {
      this.system_cpu_dom = echarts.init(this.$refs.system_cpu_dom);
      this.system_cpu_dom.setOption(
        this.createEchartsDial(this.system_cpu_data)
      );
      this.system_ram_dom = echarts.init(this.$refs.system_ram_dom);
      this.system_ram_dom.setOption(
        this.createEchartsDial(this.system_ram_data)
      );
      //createEchartsDial();
    },
    // 新增用户数据
    userDraw() {
      this.user_dom = echarts.init(this.$refs.user_dom);
      this.user_dom.setOption(this.createEchartsOptionByPie(this.user_data));
    },
    // 收益变化绘制
    profitChangeDraw() {
      this.profit_change_dom = echarts.init(this.$refs.profit_change_dom);
      this.profit_change_dom.setOption(
        this.createEchartsOptionByLine(this.profit_change)
      );
    },
    // 生成表盘
    createEchartsDial(myData) {
      let option = {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            name: myData.name,
            type: "gauge",
            detail: { formatter: "{value}%" }, //仪表盘显示数据
            axisLine: {
              //仪表盘轴线样式
              lineStyle: {
                width: 20,
              },
            },
            splitLine: {
              //分割线样式
              length: 20,
            },
            data: [{ value: myData.value, name: myData.name }],
            markPoint: {
              symbol: "circle",
              symbolSize: 5,
              data: [
                //跟你的仪表盘的中心位置对应上，颜色可以和画板底色一样
                { x: "center", y: "center", itemStyle: { color: "#FFF" } },
              ],
            },
          },
        ],
      };
      return option;
    },
    // 生成饼状图形数据
    createEchartsOptionByPie(myData) {
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        series: [
          {
            name: myData.name,
            type: "pie",
            radius: ["50%", "70%"],
            left: 0,
            width: 300,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            color: myData.color,
            data: myData.data,
          },
        ],
      };
      return option;
    },
    // 生成拆线图数据
    createEchartsOptionByLine(myData) {
      var colors = ["#5793f3", "#d14a61", "#675bba"];
      let option = {
        color: colors,
        tooltip: {
          trigger: "none",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          bottom: 0,
        },
        grid: {
          top: 20,
          bottom: 80,
        },
        xAxis: [
          {
            type: "category",
            // 刻度与刻度文字对应
            axisTick: {
              alignWithLabel: true,
            },
            // 刻度颜色
            axisLine: {
              onZero: false,
              lineStyle: {
                color: myData.data1.color,
              },
            },
            // 刻度文字旋转
            axisLabel: {
              rotate: 60,
            },
            axisPointer: {
              label: {
                formatter: function (params) {
                  return (
                    myData.data1.name +
                    " " +
                    params.value +
                    (params.seriesData.length
                      ? "：" + params.seriesData[0].data
                      : "")
                  );
                },
              },
            },
            data: myData.names,
          },
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            show: false,
            axisLine: {
              onZero: false,
              lineStyle: {
                color: myData.data2.color,
              },
            },
            axisPointer: {
              label: {
                formatter: function (params) {
                  return (
                    myData.data2.name +
                    " " +
                    params.value +
                    (params.seriesData.length
                      ? "：" + params.seriesData[0].data
                      : "")
                  );
                },
              },
            },
            data: myData.names,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: myData.data1.name,
            type: "line",
            xAxisIndex: 1,
            smooth: true,
            color: myData.data1.color,
            data: myData.data1.data,
          },
          {
            name: myData.data2.name,
            type: "line",
            smooth: true,
            color: myData.data2.color,
            data: myData.data2.data,
          },
        ],
      };

      return option;
    },
    // methods 结束
  },
};
</script>

<style scoped>
.management-agent-box {
  height: 100%;
  width: 100%;
  padding-right: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
.content_auto {
  height: calc(100% - 110px);
  overflow-y: auto;
  overflow-x: hidden;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}
/* 内容 */
.content {
  background-color: #fff;
  margin-top: 15px;
  margin-left: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  border-radius: 5px;
}
/* 数据筛选 */
.data_screen {
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}
.data_screen_title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}
/* 标题 */
.title {
  border-left: #00cb9f 3px solid;
  line-height: 15px;
  padding-left: 15px;
  margin-top: 10px;
  margin-bottom: 15px;
}
/* 中间内容 */
.content_center,
.tip_content {
  width: 100%;
  height: 300px;
}
/* 左侧标识提示盒子 */
.tip_content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
/* 左侧标识 */
.tip_color {
  display: inline-block;
  width: 24px;
  height: 14px;
  border-radius: 2px;
}
.tip {
  width: 100%;
  line-height: 30px;
  font-size: 16px;
}
.tip_value {
  position: absolute;
  text-align: right;
  right: 12%;
}
/* 底部内容 */
.content_bottom {
  width: 100%;
  height: 300px;
}
/* 弹出框表格 */
.dialog_context {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/home/home.vue